import React, { useState, useEffect } from 'react';
import AdminLayout from '../components/AdminLayout';

const API_URL = process.env.REACT_APP_API_URL || '';

// Presets de configuración SMTP
const SMTP_PRESETS = {
  office365: {
    name: 'Microsoft 365 / Office 365',
    host: 'smtp.office365.com',
    port: 587,
    secure: false, // Office 365 usa STARTTLS, no SSL directo
    tls: true,
    description: 'Para cuentas de Microsoft 365, Outlook.com o Office 365'
  },
  gmail: {
    name: 'Gmail',
    host: 'smtp.gmail.com',
    port: 587,
    secure: false,
    tls: true,
    description: 'Requiere contraseña de aplicación'
  },
  custom: {
    name: 'Configuración personalizada',
    host: '',
    port: 587,
    secure: false,
    tls: false,
    description: 'Configuración manual del servidor SMTP'
  }
};

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
    gap: '25px'
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '25px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '20px',
    color: '#333',
    paddingBottom: '15px',
    borderBottom: '2px solid #f0f0f0'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  label: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#555'
  },
  input: {
    padding: '12px 14px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.2s'
  },
  select: {
    padding: '12px 14px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none'
  },
  checkbox: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  button: {
    padding: '12px 24px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    border: 'none',
    marginTop: '10px'
  },
  primaryButton: {
    background: '#722F37',
    color: 'white'
  },
  successButton: {
    background: '#28a745',
    color: 'white'
  },
  dangerButton: {
    background: '#dc3545',
    color: 'white'
  },
  secondaryButton: {
    background: '#6c757d',
    color: 'white'
  },
  outlineButton: {
    background: 'white',
    border: '2px solid #722F37',
    color: '#722F37'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '15px'
  },
  th: {
    textAlign: 'left',
    padding: '12px 10px',
    borderBottom: '2px solid #f0f0f0',
    fontSize: '13px',
    fontWeight: '600',
    color: '#666'
  },
  td: {
    padding: '12px 10px',
    borderBottom: '1px solid #f0f0f0',
    fontSize: '14px'
  },
  badge: {
    display: 'inline-block',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '500'
  },
  badgeActive: {
    background: '#d4edda',
    color: '#155724'
  },
  badgeInactive: {
    background: '#f8d7da',
    color: '#721c24'
  },
  alert: {
    padding: '15px',
    borderRadius: '8px',
    marginBottom: '20px',
    fontSize: '14px'
  },
  alertSuccess: {
    background: '#d4edda',
    color: '#155724'
  },
  alertError: {
    background: '#f8d7da',
    color: '#721c24'
  },
  alertInfo: {
    background: '#cce5ff',
    color: '#004085'
  },
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '20px'
  },
  modalContent: {
    background: 'white',
    borderRadius: '12px',
    padding: '30px',
    width: '100%',
    maxWidth: '500px'
  },
  modalTitle: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '25px'
  },
  modalButtons: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
    marginTop: '20px'
  },
  presetCard: {
    border: '2px solid #e0e0e0',
    borderRadius: '10px',
    padding: '15px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    marginBottom: '10px'
  },
  presetCardSelected: {
    borderColor: '#722F37',
    background: '#faf5f5'
  },
  presetName: {
    fontWeight: '600',
    fontSize: '14px',
    color: '#333'
  },
  presetDescription: {
    fontSize: '12px',
    color: '#666',
    marginTop: '4px'
  },
  hint: {
    fontSize: '12px',
    color: '#666',
    marginTop: '5px',
    lineHeight: '1.4'
  },
  divider: {
    borderTop: '1px solid #e0e0e0',
    margin: '20px 0'
  }
};

function AdminSettings() {
  const [selectedPreset, setSelectedPreset] = useState('office365');
  const [smtpConfig, setSmtpConfig] = useState({
    host: 'smtp.office365.com',
    port: 587,
    secure: false,
    tls: true,
    user: 'pedro.pelaez@emiliomoro.com',
    password: '',
    from_name: 'RRHH - Bodegas Emilio Moro',
    from_email: 'rrhh@emiliomoro.com'
  });
  const [campaigns, setCampaigns] = useState([]);
  const [showCampaignModal, setShowCampaignModal] = useState(false);
  const [newCampaign, setNewCampaign] = useState({
    nombre: '',
    descripcion: '',
    fecha_inicio: '',
    fecha_fin: ''
  });
  const [message, setMessage] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(true);
  const [testingEmail, setTestingEmail] = useState(false);
  const [testEmail, setTestEmail] = useState('');
  const [backupSettings, setBackupSettings] = useState({
    interval_hours: 12,
    keep_count: 3,
    enabled: true
  });
  const [isSuperadmin, setIsSuperadmin] = useState(false);

  const fetchData = async () => {
    const token = localStorage.getItem('adminToken');
    const headers = { Authorization: `Bearer ${token}` };

    // Check if superadmin from token
    try {
      const tokenData = JSON.parse(atob(token.split('.')[1]));
      setIsSuperadmin(tokenData.role === 'superadmin');
    } catch (e) {
      setIsSuperadmin(false);
    }

    try {
      const [smtpRes, campaignsRes] = await Promise.all([
        fetch(`${API_URL}/api/admin/smtp`, { headers }),
        fetch(`${API_URL}/api/admin/campaigns`, { headers })
      ]);

      const smtpData = await smtpRes.json();
      if (smtpData.host) {
        setSmtpConfig(prev => ({ ...prev, ...smtpData }));
        // Detect preset
        if (smtpData.host === 'smtp.office365.com') {
          setSelectedPreset('office365');
        } else if (smtpData.host === 'smtp.gmail.com') {
          setSelectedPreset('gmail');
        } else {
          setSelectedPreset('custom');
        }
      }

      setCampaigns(await campaignsRes.json());

      // Fetch backup settings if superadmin
      try {
        const backupRes = await fetch(`${API_URL}/api/superadmin/backup-settings`, { headers });
        if (backupRes.ok) {
          const backupData = await backupRes.json();
          setBackupSettings(backupData);
          setIsSuperadmin(true);
        }
      } catch (e) {
        // Not superadmin or endpoint not available
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handlePresetChange = (preset) => {
    setSelectedPreset(preset);
    const config = SMTP_PRESETS[preset];
    setSmtpConfig(prev => ({
      ...prev,
      host: config.host,
      port: config.port,
      secure: config.secure,
      tls: config.tls
    }));
  };

  const handleSaveSmtp = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('adminToken');

    try {
      const res = await fetch(`${API_URL}/api/admin/smtp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(smtpConfig)
      });

      if (res.ok) {
        setMessage({ type: 'success', text: 'Configuración SMTP guardada correctamente' });
      } else {
        throw new Error();
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Error al guardar la configuración' });
    }

    setTimeout(() => setMessage({ type: '', text: '' }), 3000);
  };

  const handleTestEmail = async () => {
    if (!testEmail) {
      setMessage({ type: 'error', text: 'Introduce un email de prueba' });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      return;
    }

    setTestingEmail(true);
    const token = localStorage.getItem('adminToken');

    try {
      const res = await fetch(`${API_URL}/api/admin/smtp/test`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ testEmail })
      });

      const data = await res.json();

      if (res.ok) {
        setMessage({ type: 'success', text: 'Email de prueba enviado correctamente. Revisa tu bandeja de entrada.' });
      } else {
        setMessage({ type: 'error', text: `Error: ${data.error || 'No se pudo enviar el email'}` });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Error de conexión al probar el email' });
    } finally {
      setTestingEmail(false);
      setTimeout(() => setMessage({ type: '', text: '' }), 5000);
    }
  };

  const handleSaveBackupSettings = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('adminToken');

    try {
      const res = await fetch(`${API_URL}/api/superadmin/backup-settings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(backupSettings)
      });

      if (res.ok) {
        const data = await res.json();
        setBackupSettings(data);
        setMessage({ type: 'success', text: 'Configuración de backups guardada correctamente' });
      } else {
        throw new Error();
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Error al guardar la configuración de backups' });
    }

    setTimeout(() => setMessage({ type: '', text: '' }), 3000);
  };

  const handleCreateCampaign = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('adminToken');

    try {
      const res = await fetch(`${API_URL}/api/admin/campaigns`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(newCampaign)
      });

      if (res.ok) {
        setShowCampaignModal(false);
        setNewCampaign({ nombre: '', descripcion: '', fecha_inicio: '', fecha_fin: '' });
        fetchData();
        setMessage({ type: 'success', text: 'Campaña creada correctamente' });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Error al crear la campaña' });
    }

    setTimeout(() => setMessage({ type: '', text: '' }), 3000);
  };

  const handleToggleCampaign = async (id) => {
    const token = localStorage.getItem('adminToken');

    await fetch(`${API_URL}/api/admin/campaigns/${id}/toggle`, {
      method: 'PUT',
      headers: { Authorization: `Bearer ${token}` }
    });

    fetchData();
  };

  if (loading) {
    return (
      <AdminLayout title="Configuración">
        <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>Cargando...</div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout title="Configuración">
      {message.text && (
        <div style={{
          ...styles.alert,
          ...(message.type === 'success' ? styles.alertSuccess : message.type === 'info' ? styles.alertInfo : styles.alertError)
        }}>
          {message.text}
        </div>
      )}

      <div style={styles.grid}>
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>Configuración de Email (SMTP)</h3>

          {/* Preset selector */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ ...styles.label, marginBottom: '10px', display: 'block' }}>
              Selecciona tu proveedor de email
            </label>
            {Object.entries(SMTP_PRESETS).map(([key, preset]) => (
              <div
                key={key}
                style={{
                  ...styles.presetCard,
                  ...(selectedPreset === key ? styles.presetCardSelected : {})
                }}
                onClick={() => handlePresetChange(key)}
              >
                <div style={styles.presetName}>
                  {selectedPreset === key && '✓ '}{preset.name}
                </div>
                <div style={styles.presetDescription}>{preset.description}</div>
              </div>
            ))}
          </div>

          {selectedPreset === 'office365' && (
            <div style={{ ...styles.alert, ...styles.alertInfo, marginBottom: '20px' }}>
              <strong>Configuración para Office 365:</strong>
              <ul style={{ margin: '10px 0 0 20px', fontSize: '13px' }}>
                <li>El usuario debe ser tu email completo de Office 365</li>
                <li>Si tienes MFA activado, necesitarás crear una <strong>contraseña de aplicación</strong></li>
                <li>Ve a: account.microsoft.com → Seguridad → Contraseñas de aplicación</li>
              </ul>
            </div>
          )}

          <form style={styles.form} onSubmit={handleSaveSmtp}>
            {selectedPreset === 'custom' && (
              <>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Servidor SMTP</label>
                  <input
                    type="text"
                    style={styles.input}
                    placeholder="smtp.ejemplo.com"
                    value={smtpConfig.host}
                    onChange={(e) => setSmtpConfig({ ...smtpConfig, host: e.target.value })}
                  />
                </div>

                <div style={{ display: 'flex', gap: '15px' }}>
                  <div style={{ ...styles.inputGroup, flex: 1 }}>
                    <label style={styles.label}>Puerto</label>
                    <input
                      type="number"
                      style={styles.input}
                      value={smtpConfig.port}
                      onChange={(e) => setSmtpConfig({ ...smtpConfig, port: parseInt(e.target.value) })}
                    />
                  </div>
                  <div style={{ ...styles.inputGroup, flex: 1 }}>
                    <label style={styles.label}>Seguridad</label>
                    <select
                      style={styles.select}
                      value={smtpConfig.secure ? 'ssl' : smtpConfig.tls ? 'tls' : 'none'}
                      onChange={(e) => setSmtpConfig({
                        ...smtpConfig,
                        secure: e.target.value === 'ssl',
                        tls: e.target.value === 'tls'
                      })}
                    >
                      <option value="tls">STARTTLS (Puerto 587)</option>
                      <option value="ssl">SSL/TLS (Puerto 465)</option>
                      <option value="none">Sin cifrar</option>
                    </select>
                  </div>
                </div>
              </>
            )}

            {selectedPreset !== 'custom' && (
              <div style={{ background: '#f8f9fa', padding: '12px', borderRadius: '8px', fontSize: '13px', color: '#666' }}>
                <strong>Servidor:</strong> {smtpConfig.host} | <strong>Puerto:</strong> {smtpConfig.port} | <strong>Seguridad:</strong> STARTTLS
              </div>
            )}

            <div style={styles.inputGroup}>
              <label style={styles.label}>Email de la cuenta (Usuario)</label>
              <input
                type="email"
                style={styles.input}
                placeholder="tu.email@emiliomoro.com"
                value={smtpConfig.user}
                onChange={(e) => setSmtpConfig({ ...smtpConfig, user: e.target.value })}
              />
              <div style={styles.hint}>
                Tu dirección de email completa de Office 365
              </div>
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Contraseña</label>
              <input
                type="password"
                style={styles.input}
                value={smtpConfig.password}
                onChange={(e) => setSmtpConfig({ ...smtpConfig, password: e.target.value })}
                placeholder="••••••••"
              />
              <div style={styles.hint}>
                Si tienes MFA activado, usa una contraseña de aplicación
              </div>
            </div>

            <div style={styles.divider}></div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Nombre del remitente</label>
              <input
                type="text"
                style={styles.input}
                value={smtpConfig.from_name}
                onChange={(e) => setSmtpConfig({ ...smtpConfig, from_name: e.target.value })}
                placeholder="Bodegas Emilio Moro"
              />
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Email del remitente</label>
              <input
                type="email"
                style={styles.input}
                value={smtpConfig.from_email}
                onChange={(e) => setSmtpConfig({ ...smtpConfig, from_email: e.target.value })}
                placeholder="encuesta@emiliomoro.com"
              />
              <div style={styles.hint}>
                Debe ser el mismo que el email de la cuenta o un alias autorizado
              </div>
            </div>

            <button type="submit" style={{ ...styles.button, ...styles.primaryButton }}>
              Guardar Configuración
            </button>
          </form>

          <div style={styles.divider}></div>

          {/* Test email section */}
          <div>
            <label style={{ ...styles.label, marginBottom: '10px', display: 'block' }}>
              Probar configuración
            </label>
            <div style={{ display: 'flex', gap: '10px' }}>
              <input
                type="email"
                style={{ ...styles.input, flex: 1 }}
                placeholder="email@ejemplo.com"
                value={testEmail}
                onChange={(e) => setTestEmail(e.target.value)}
              />
              <button
                type="button"
                style={{ ...styles.button, ...styles.outlineButton, marginTop: 0 }}
                onClick={handleTestEmail}
                disabled={testingEmail}
              >
                {testingEmail ? 'Enviando...' : 'Enviar Prueba'}
              </button>
            </div>
          </div>
        </div>

        <div style={styles.card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3 style={{ ...styles.cardTitle, marginBottom: 0, paddingBottom: 0, borderBottom: 'none' }}>
              Campañas de Encuesta
            </h3>
            <button
              style={{ ...styles.button, ...styles.successButton, marginTop: 0 }}
              onClick={() => setShowCampaignModal(true)}
            >
              Nueva Campaña
            </button>
          </div>

          {campaigns.length === 0 ? (
            <p style={{ color: '#888', textAlign: 'center', padding: '20px' }}>
              No hay campañas creadas
            </p>
          ) : (
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Nombre</th>
                  <th style={styles.th}>Fechas</th>
                  <th style={styles.th}>Estado</th>
                  <th style={styles.th}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {campaigns.map(campaign => (
                  <tr key={campaign.id}>
                    <td style={styles.td}>
                      <strong>{campaign.nombre}</strong>
                      {campaign.descripcion && (
                        <div style={{ fontSize: '12px', color: '#888', marginTop: '3px' }}>
                          {campaign.descripcion}
                        </div>
                      )}
                    </td>
                    <td style={styles.td}>
                      <div style={{ fontSize: '13px' }}>
                        {campaign.fecha_inicio} - {campaign.fecha_fin}
                      </div>
                    </td>
                    <td style={styles.td}>
                      <span style={{
                        ...styles.badge,
                        ...(campaign.activa ? styles.badgeActive : styles.badgeInactive)
                      }}>
                        {campaign.activa ? 'Activa' : 'Inactiva'}
                      </span>
                    </td>
                    <td style={styles.td}>
                      <button
                        style={{
                          ...styles.button,
                          ...(campaign.activa ? styles.dangerButton : styles.successButton),
                          padding: '6px 12px',
                          fontSize: '12px',
                          marginTop: 0
                        }}
                        onClick={() => handleToggleCampaign(campaign.id)}
                      >
                        {campaign.activa ? 'Desactivar' : 'Activar'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Configuración de Backups - Solo Superadmin */}
        {isSuperadmin && (
          <div style={styles.card}>
            <h3 style={styles.cardTitle}>Configuración de Backups</h3>
            <form style={styles.form} onSubmit={handleSaveBackupSettings}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>
                  <input
                    type="checkbox"
                    checked={backupSettings.enabled}
                    onChange={(e) => setBackupSettings({ ...backupSettings, enabled: e.target.checked })}
                    style={{ marginRight: '8px' }}
                  />
                  Backups automáticos habilitados
                </label>
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>Intervalo entre backups</label>
                <select
                  style={styles.select}
                  value={backupSettings.interval_hours}
                  onChange={(e) => setBackupSettings({ ...backupSettings, interval_hours: parseInt(e.target.value) })}
                  disabled={!backupSettings.enabled}
                >
                  <option value={6}>Cada 6 horas</option>
                  <option value={12}>Cada 12 horas</option>
                  <option value={24}>Cada 24 horas (diario)</option>
                  <option value={48}>Cada 48 horas</option>
                  <option value={168}>Cada semana</option>
                </select>
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>Número de copias a mantener</label>
                <select
                  style={styles.select}
                  value={backupSettings.keep_count}
                  onChange={(e) => setBackupSettings({ ...backupSettings, keep_count: parseInt(e.target.value) })}
                  disabled={!backupSettings.enabled}
                >
                  <option value={3}>3 copias</option>
                  <option value={5}>5 copias</option>
                  <option value={7}>7 copias</option>
                  <option value={10}>10 copias</option>
                  <option value={15}>15 copias</option>
                </select>
              </div>

              <div style={{
                padding: '12px',
                background: '#f5f5f5',
                borderRadius: '8px',
                fontSize: '13px',
                color: '#666'
              }}>
                <strong>Configuración actual:</strong><br/>
                {backupSettings.enabled ? (
                  <>
                    Backup automático cada <strong>{backupSettings.interval_hours} horas</strong><br/>
                    Se mantienen las últimas <strong>{backupSettings.keep_count} copias</strong>
                  </>
                ) : (
                  <span style={{ color: '#c00' }}>Backups automáticos deshabilitados</span>
                )}
              </div>

              <button type="submit" style={{ ...styles.button, ...styles.primaryButton }}>
                Guardar Configuración de Backups
              </button>
            </form>
          </div>
        )}
      </div>

      {showCampaignModal && (
        <div style={styles.modal} onClick={() => setShowCampaignModal(false)}>
          <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
            <h2 style={styles.modalTitle}>Nueva Campaña de Encuesta</h2>
            <form style={styles.form} onSubmit={handleCreateCampaign}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Nombre *</label>
                <input
                  type="text"
                  style={styles.input}
                  value={newCampaign.nombre}
                  onChange={(e) => setNewCampaign({ ...newCampaign, nombre: e.target.value })}
                  required
                />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Descripción</label>
                <input
                  type="text"
                  style={styles.input}
                  value={newCampaign.descripcion}
                  onChange={(e) => setNewCampaign({ ...newCampaign, descripcion: e.target.value })}
                />
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ ...styles.inputGroup, flex: 1 }}>
                  <label style={styles.label}>Fecha inicio</label>
                  <input
                    type="date"
                    style={styles.input}
                    value={newCampaign.fecha_inicio}
                    onChange={(e) => setNewCampaign({ ...newCampaign, fecha_inicio: e.target.value })}
                  />
                </div>
                <div style={{ ...styles.inputGroup, flex: 1 }}>
                  <label style={styles.label}>Fecha fin</label>
                  <input
                    type="date"
                    style={styles.input}
                    value={newCampaign.fecha_fin}
                    onChange={(e) => setNewCampaign({ ...newCampaign, fecha_fin: e.target.value })}
                  />
                </div>
              </div>
              <div style={styles.modalButtons}>
                <button
                  type="button"
                  style={{ ...styles.button, background: '#e0e0e0', color: '#333', marginTop: 0 }}
                  onClick={() => setShowCampaignModal(false)}
                >
                  Cancelar
                </button>
                <button type="submit" style={{ ...styles.button, ...styles.primaryButton, marginTop: 0 }}>
                  Crear Campaña
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}

export default AdminSettings;
